import { DangerousHtmlContent, Notification, variants } from '@eti/components';
import { useTranslation } from '@eti/providers';
import type { TripChange } from '../../models';

interface StopLossPriceChangeNotificationProps {
  isPotentialStopLossChange: boolean;
  tripChange: TripChange;
}

const StopLossPriceChangeNotification = ({
  isPotentialStopLossChange,
  tripChange,
}: StopLossPriceChangeNotificationProps) => {
  const { t } = useTranslation();

  return !tripChange.price && isPotentialStopLossChange ? (
    <Notification
      dataTestId="paymentPage-priceChangeNotification-TripNotification"
      variant={variants.INFORMATION}
    >
      <DangerousHtmlContent content={t('Notification.PriceIncrease.StopLoss.Message')} />
    </Notification>
  ) : null;
};

export default StopLossPriceChangeNotification;
